var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('preview',{attrs:{"filename":_vm.filename(this.$route.query),"preview-contents":_vm.editedAgreement,"showWatermark":_vm.showWatermark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }